/* eslint-disable max-len */
import { Navbar2Element, NavbarLink } from '@typedream/core';
import { createMachine } from 'xstate';
import { assign } from '@xstate/immer';
import { cloneDeep } from 'lodash';
import { ToolbarNavbarMenuItemDropEvent } from '../../../types';

type NavbarContainerOptionsContext = {
  uiIsShowingMenu: boolean;
  dataNavbar?: Navbar2Element;
};

type NavbarContainerOptionsEvent =
  | { type: 'MENU.OPEN'; payload: { newNavbar: Navbar2Element } }
  | { type: 'MENU.CLOSE' }
  | { type: 'POINTER.NAVBAR.ENTER' }
  | { type: 'POINTER.NAVBAR.LEAVE' }
  | { type: 'POINTER.MENU.ENTER' }
  | { type: 'POINTER.MENU.LEAVE' }
  | { type: 'POINTER.DROPDOWN_MENU.ENTER' }
  | { type: 'POINTER.DROPDOWN_MENU.LEAVE' }
  | { type: 'NAVBAR.ALIGNMENT.CHANGE'; payload: { newAlign: Navbar2Element['alignment'] } }
  | { type: 'NAVBAR.POSITION.CHANGE'; payload: Navbar2Element['position'] }
  | { type: 'NAVBAR.STYLE.CHANGE'; payload: Navbar2Element['style'] }
  | { type: 'NAVBAR.BLUR.CHANGE'; payload: boolean }
  | { type: 'NAVBAR.REMOVE.CANCEL' }
  | { type: 'NAVBAR.REMOVE.CONFIRM' }
  | { type: 'NAVBAR.REMOVE.SHOW_DIALOG' }
  | { type: 'MENU_ITEM.MIDDLE.ADD' }
  | { type: 'MENU_ITEM.END.ADD' }
  | { type: 'MENU_ITEM.DROP'; payload: ToolbarNavbarMenuItemDropEvent };
export const navbarContainerOptionsMachine =
  /** @xstate-layout N4IgpgJg5mDOIC5QDkCGA3ARqgTgYQHsA7AF1QEsiwcB5ABxPONgFEJySCcAxAZQFkAdPzBEAroICSEADZgAxPxbIAqoJoAFZQG0ADAF1EoOgVgcmRIyAAeiAIwPdggCwBmAJwBWAGy73uu2dPXQB2ABoQAE97VxDBd29XACZnb090kLSvAF9siLQsXEJSCipaBgtWdk4eAWFRCV4ACwIAd0ooAAIAWwbFZTU8ABkaXhY9QyQQEzNGYitbBEDMwXSADmcQ92TdZzskiOiEJM9BNdc9-29vNYdU11dc-IxsfGIySmp6OaIqji4+EIROJBM02h0en1kABBABqACFoQAlQRIlj8GiwliggASNAA6gB9AAikmhIwA4hMrDNzPMpotbqcku5HO4UkkQlz3IdEKzTrskr5dEldLoLkkniACq9ih8yt9Kmx-rUgQ1QS12kQur0QdCZOQoEROgQKsRISDpHJ5DCEcjBOTJBTkEpkAAVQR4HHQ5AU8YGGmmOmWBkxNyrJJ3HweLwhA5RRCeZzuCP+EWeEJudJ2KUyorvUpfM2-ZU1QH1EFgrU69UaIM-E3Fi0SK0KW2IlEaUaSN2SGjIT3e33+ybGesWBZ8uyuM4BbyckJ2bPs3kIJNxNZrRJCuxc5POZy5l75kqfco-P5lurAxqaiG6xokSJyRsNh9SWRtuEd0FugCaQzYl6Pp+tSUy0j8k5LHGzgRs4nLTr4ITiq4q7pE4kYBByoQSmsR6FG8p4KsWl4Ate6pVve6rwjIYg4K+FjNh+1rtva8JDCoKLAcOYFjrME6hscdjzoILLeKyoSZq4gRoT4gjeHY7iZl4dibq4Gz4bKBZnoqzClmRaqVpqnQQGAcgkGAnREMe9HsKgMgEFANrfvaaIYlinr9twkhIvwvHTOO9KgIsbhrIIrhis4axeK4Pjij4q6cmFCmLgk0XSUE3iaSe8pFhe+mqhWt5tCZZlgBZVk2SZ5D2Y5zl2iibmYkBPp4CwQz+RBAnBYgvhhSEnj+OciTsp4azxkcor9XGiSLnGXKzdlhG5eeSrVAZgh1pQFk4MxChdpI7osCixJIpoxIEsghKumoyhusdnWBSGPUIAAtA4tyCB99yxSkQTOKuiSieJIQbKyCSpGkS1yoWq16ethVbaQ1B7fIB1HSirEondD0BuBT1Qa9qSnNJnL+O4-03Ikq52LopzOCKiRLhFQpRYeeTSjZMM6SRBXlkjO1SL85CmZ0eY4GjNCHfdJ1nRoF34ldN2CDjSKPfxQU2Igr2bnY4VrHGoqcmNQThAmSybIIOGeLTsQfec0PacR+UI-zBDbSjkjC6L4uS9Lx2CFjgiAXCI6Bhrz1a29NynOk3jJpGtzTgbq7qSmqSpCcwlLv9jtEXla0qm7Hu7fiFCMNqfsY8IAwqxj6vBoT+wppF+yckkGxBEmgOiuFB6qZGiS+LEecrbpJau3UAso2X5iV+jMuBy52P13jfGN4Jr2eBF8TJhT6QsnTUVoeKZyLvHsW7IE6mj7D4+kYj7vI6X5cdPI1iwGQFmCKgABmO0AApgi6AAJQ2i5k7Au8Mi5TyfoLWeFcoAN0goJeCggtgJBtgzTBwQ7CJREmKecrg0gnGQkKW+PMXYwKENPXaXszCi25mUAA5LAToN4q6L2ViHLEyDupR1eh3OISQHjxVBu4NYGQ0K7nCuKcSCR5GLk8BQ52hcrw0LgZ7b2llxadGJDgU0EA2jGg4QvAOp1zqXWurXHhYd8YRybruJILh-CDQeAtUG3hVxRRTMkacC4lwbHnCoqBE9qGbU0S-OeXQIAGLoEY1oxoHycPMXLBWSta6qz4ZrRYr0EgzhFI4JcXg9jCTQv4K2+wUobF0JuNwIS4ZhPUREkuggEEQliYY4xzZ36f1QN-P+gDRSgPAQRJhoSH7F2fm01+2oTJxISUkho2TI65OFGcec1tfqxTWKuLk-UVK7GQhgjMDT7583IuIToHAwDdDYQAY0gXQz8-RVCEh7OiQQFiNArMcbFWcexgjYI8N4M2Rwt5bCtkpJSWx5wGzObzSehkxDXIsnczojz87POtDdd590gSSGJMSQCDoiW-M3g4He1xMwkN2JIg8q4iaeGcZyWI8EhQeFikEBFVDmk3lRbch5TzUa4o+UIZQxJSXEnJS9d6uhxLxHSlNOa7gVzm0EUEPuexrgG3bnsdmHMiAEFMvAKY4txmNMmQIcOG9ZXTlUl9JIpCbgij2LFRlA1YIHluIfHc3qeVqI2jeG1KCXoXCcIuLuoKbbpDGp4RlCkzgM3GruGFrKlwBugXy9UrYQ38MWOpfqgQ44DSXOseN5tgirD8CkOmWwhGKXZs8MZTzzlIqKhqcEcyHx5pyYgW4G45wBOXBNRAsRnHb0Gj4fJCQQiZqaUGiid5u3qn1IaY0po3wNF7as+wLJY6RmLSNWMo6ECpD1vS4STr9wXC3POq1yLO3ViYmuo0DFzTvlzfY21Udk562HtG4moKZLm2QrBdcIQPAnGTINPCHNzWtsReEm8T6qIgjrBHd9SzxA7qgluU4awh1cjLYpU9qQMIOECEuY5EU53wYgVittyGl1dprOhp6WGmJfvXqG39gQwpJmGvxjBuzzY3BnAba45MhSRmZfei5j7KIrsrE+F8m7GI9u-bxxYwkVjMvgouYhoQULeJEpOjuhaOQnCyvRltjGkPZqMqxpivBVOWXUx+nNn5cOCVUn4L6bgsIurpkKPZwl4iqtVYEVkCklLyfbShpTbGJA0TopxzTPH82ICNs4uMuwDyZCCMW0zYUKaZWTPsUIqQ6PNq0vZ3li6nPPvfKl+iHnsMtm81prLxxjPoNFAeTY8csEVqOGkf9A1o0XHXPseLzGmulXMpZayBFqq1SgD5l6B4UyqV8MyxSi5amoVA9cdBW5YoSMgwbWpc3mm0M2wItuO3VI-X0-9Rlg0AtbmzrGrYXLbsbVoXtB7uTxqKrTtC4ZoNEoCY5fk2mMnYMA8fq0+hIsdE2RB9rZlYV5UiK3NFQIvgAbmxSKcalh6RR+H2HB2rOU74OcB5EmZ0SsdvRBfJc4SZ+4XAUqeyD3gXAXAZjcLk6RVXI6mYLNHjCnmsPYdu7rfa3qyZcHTKLJslLzjIw4USzLQjbxuGJWKkvYGo+0WLKq+iumJIVzhpXu63oOEhbTUIHdpy1Ncfg3Huw-DEOwcmWnnM7Nj0Zyj6Z7S5mdPid0jLAUHEUrbvEMSIX2WDS8aB4hQu3DXGCB4Grwe6uh4a4VflNz0WYpWmz96nInBtwzC6lI05Rva2uILrk0l5zTsSCPWzReGcl-LGXtFQqsXA4d03J1zj6+ZEI03916rpJxFZCyTY05Njyt77kIAA */
  createMachine(
    {
      tsTypes: {} as import('./NavbarContainer.fsm.typegen').Typegen0,
      id: 'NavbarContainerOptionsEditorFSM',
      predictableActionArguments: true,
      states: {
        Menu: {
          states: {
            Idle: {
              on: {
                'MENU.OPEN': {
                  target: 'Showing menu',
                  description:
                    "Hovering the navbar will open the container's menu. We also assign the reference of the navbar from the editor here.",
                  actions: ['assignMenuNodeRef', 'assignNavbarToContext'],
                },
              },
            },

            'Showing menu': {
              tags: ['ui:show_menu'],
              states: {
                'Align option menu': {
                  states: {
                    Idle: {
                      on: {
                        'NAVBAR.ALIGNMENT.CHANGE': {
                          target: 'Idle',
                          internal: true,
                          actions: ['assignAlignmentToContext', 'effectUpdateSlateNavbarNode'],
                        },
                      },
                    },
                  },

                  initial: 'Idle',
                },

                'Position option menu': {
                  states: {
                    Idle: {
                      on: {
                        'NAVBAR.POSITION.CHANGE': {
                          target: 'Idle',
                          internal: true,
                          actions: ['assignPositionOptionToContext', 'effectUpdateSlateNavbarNode'],
                        },
                      },
                    },
                  },

                  initial: 'Idle',
                },

                'Style option menu': {
                  states: {
                    Idle: {
                      on: {
                        'NAVBAR.STYLE.CHANGE': {
                          target: 'Idle',
                          internal: true,
                          actions: ['assignStylesToContext', 'effectUpdateSlateNavbarNode'],
                        },
                      },
                    },
                  },

                  initial: 'Idle',
                },

                'Blur option menu': {
                  states: {
                    Idle: {
                      on: {
                        'NAVBAR.BLUR.CHANGE': {
                          target: 'Idle',
                          internal: true,
                          actions: ['assignBlurToContext', 'effectUpdateSlateNavbarNode'],
                        },
                      },
                    },
                  },

                  initial: 'Idle',
                },
              },

              type: 'parallel',

              on: {
                'MENU.CLOSE': {
                  target: 'Idle',
                  description: `TODO: This could be removed and we can listen to the context instead.`,
                },
                'NAVBAR.REMOVE.SHOW_DIALOG': 'Show delete navbar dialog',
              },
            },

            'Show delete navbar dialog': {
              tags: ['ui:show_delete_navbar_dialog'],
              on: {
                'NAVBAR.REMOVE.CONFIRM': {
                  target: 'Idle',
                  actions: ['removeNavbarFromContext', 'effectUpdateSlateNavbarNode'],
                },
                'NAVBAR.REMOVE.CANCEL': 'Idle',
              },
            },
          },

          initial: 'Idle',
        },

        Pointer: {
          states: {
            Idle: {
              on: {
                'POINTER.DROPDOWN_MENU.ENTER': {
                  target: 'Inside Navbar Dropdown Menu',
                  actions: 'assignPointerStateToContext',
                },

                'POINTER.NAVBAR.ENTER': {
                  target: 'Inside Navbar',
                  actions: 'assignPointerStateToContext',
                },
              },
            },

            'Inside Navbar': {
              tags: ['ui:show_menu'],
              on: {
                'POINTER.DROPDOWN_MENU.ENTER': {
                  target: 'Inside Navbar Dropdown Menu',
                  actions: 'assignPointerStateToContext',
                },

                'POINTER.NAVBAR.LEAVE': {
                  target: 'Waiting',
                  actions: 'assignPointerStateToContext',
                },
              },
            },

            Waiting: {
              description:
                'This state helps us transition from inside navbar to inside menu. It will wait for defined time before hiding the menu',
              tags: ['ui:show_menu'],
              after: {
                500: {
                  target: 'Idle',
                  actions: 'assignPointerStateToContext',
                },
              },

              on: {
                'POINTER.MENU.ENTER': {
                  target: "Inside Container's Menu",
                  actions: 'assignPointerStateToContext',
                },

                'POINTER.NAVBAR.ENTER': {
                  target: 'Inside Navbar',
                  actions: 'assignPointerStateToContext',
                },
              },
            },

            "Inside Container's Menu": {
              tags: ['ui:show_menu'],
              on: {
                'POINTER.MENU.LEAVE': {
                  target: 'Waiting',
                  actions: 'assignPointerStateToContext',
                },
              },
            },

            'Inside Navbar Dropdown Menu': {
              tags: ['ui:force_hide_menu'],
              on: {
                'POINTER.DROPDOWN_MENU.LEAVE': {
                  target: 'Waiting dropdown menu',
                  actions: 'assignPointerStateToContext',
                },
              },
            },

            'Waiting dropdown menu': {
              description:
                "this state prevent flashing navbar's container toolbar when user hover the dropdown menu",
              on: {
                'POINTER.DROPDOWN_MENU.ENTER': {
                  target: 'Inside Navbar Dropdown Menu',
                  actions: 'assignPointerStateToContext',
                },
              },

              after: {
                200: 'Waiting',
              },
            },
          },

          initial: 'Idle',
        },

        'Menu items container': {
          states: {
            Idle: {
              on: {
                'MENU_ITEM.DROP': {
                  target: 'Idle',
                  internal: true,
                  actions: ['assignDroppedMenuItemToContext', 'effectUpdateSlateNavbarNode'],
                },

                'MENU_ITEM.MIDDLE.ADD': {
                  target: 'Idle',
                  internal: true,
                  actions: ['assignNewMiddleMenuToContext', 'effectUpdateSlateNavbarNode'],
                },

                'MENU_ITEM.END.ADD': {
                  target: 'Idle',
                  internal: true,
                  actions: ['assignNewEndMenuToContext', 'effectUpdateSlateNavbarNode'],
                },
              },
            },
          },

          initial: 'Idle',
        },
      },
      schema: {
        context: {} as NavbarContainerOptionsContext,
        events: {} as NavbarContainerOptionsEvent,
      },

      type: 'parallel',
      context: {
        uiIsShowingMenu: false,
      },
    },
    {
      actions: {
        assignNewMiddleMenuToContext: assign((context) => {
          if (context.dataNavbar) {
            const newMiddleMenu: NavbarLink = {
              type: 'link',
              title: 'Menu',
              color: 'default',
            };

            context.dataNavbar.menu.push(newMiddleMenu);
          }
        }),
        // TODO: check wether we still need `cloneDeep` or not
        assignDroppedMenuItemToContext: assign((context, event) => {
          const { from, to } = event.payload;
          if (context.dataNavbar) {
            const { dataNavbar } = context;
            const clonedDataNavbar = cloneDeep(dataNavbar);

            const fromMenuType = from.endMenu ? 'endMenu' : 'menu';
            const clonedFromMenuItem = cloneDeep(dataNavbar[fromMenuType][from.index]);

            // delete the "from" menu item
            clonedDataNavbar[fromMenuType].splice(from.index, 1);

            const toMenuType = to.endMenu ? 'endMenu' : 'menu';

            clonedDataNavbar[toMenuType].splice(to.index, 0, clonedFromMenuItem);

            context.dataNavbar = clonedDataNavbar;
          }
        }),
        assignNewEndMenuToContext: assign((context) => {
          if (context.dataNavbar) {
            const newEndMenu: NavbarLink = {
              type: 'link',
              title: 'Menu',
              color: 'default',
            };

            context.dataNavbar.endMenu.unshift(newEndMenu);
          }
        }),
        assignStylesToContext: assign((context, event) => {
          if (context.dataNavbar) {
            const newStyle: Navbar2Element['style'] = event.payload;
            context.dataNavbar.style = newStyle;
          }
        }),
        assignBlurToContext: assign((context, event) => {
          if (context.dataNavbar) {
            const newBlur: Navbar2Element['isBlur'] = event.payload;
            context.dataNavbar.isBlur = newBlur;
          }
        }),
        assignNavbarToContext: assign((context, event) => {
          if (event.type === 'MENU.OPEN') {
            context.dataNavbar = event.payload.newNavbar;
          }
        }),
        assignPositionOptionToContext: assign((context, event) => {
          if (context?.dataNavbar) {
            const newPosition = event.payload;
            context.dataNavbar.position = newPosition;
          }
        }),
        assignAlignmentToContext: assign((context, event) => {
          if (context?.dataNavbar) {
            const newAligment = event.payload.newAlign;
            context.dataNavbar.alignment = newAligment;
          }
        }),
        removeNavbarFromContext: assign((context) => {
          context.uiIsShowingMenu = false;
          context.dataNavbar = undefined;
        }),
        assignMenuNodeRef: () => {},
        assignPointerStateToContext: assign((context, event) => {
          let newUIIsShowingMenu: boolean;
          switch (event.type) {
            case 'POINTER.MENU.LEAVE':
            case 'POINTER.MENU.ENTER':
            case 'POINTER.NAVBAR.LEAVE':
            case 'POINTER.NAVBAR.ENTER':
            case 'POINTER.DROPDOWN_MENU.LEAVE':
              newUIIsShowingMenu = true;
              break;

            case 'POINTER.DROPDOWN_MENU.ENTER':
            case 'xstate.after(500)#NavbarContainerOptionsEditorFSM.Pointer.Waiting':
              newUIIsShowingMenu = false;
              break;

            default: {
              newUIIsShowingMenu = context.uiIsShowingMenu;
            }
          }

          context.uiIsShowingMenu = newUIIsShowingMenu;
        }),
      },
    }
  );

export type NavbarContainerOptionsMachineType = typeof navbarContainerOptionsMachine;
